import { Route, Routes } from "fusion-plugin-react-router";
import { LiveChatScript } from "./shared/utils/globalScripts";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";

// Auth & Error
import UberAuthRedirect from "./pages/UberAuthRedirect";
import UberAuthCallback from "./pages/UberAuthCallback";
import ErrorPage from "./pages/ErrorPage";
import NotFound from "./pages/NotFound";
import BlockedAction from "./pages/BlockedAction";

// Portal
import LandingLayout from "./features/portal/pages/dashboard/LandingLayout";
import HomePage from "./features/portal/pages/dashboard/HomePage";
import ContactPage from "./features/portal/pages/dashboard/ContactPage";
import Support from "./features/portal/pages/support/support";
import PortalDocuments from "./features/portal/pages/documents/PortalDocuments";
import ReportClaimLayout from "./features/portal/pages/reportClaim/reportClaimLayout";
import ProtectedRoute from "./shared/components/protectedRoute";
import TaxiJourney from "./pages/TaxiJourney";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TaxiLandingPage from "./pages/TaxiLandingPage";

// Admin
import AdminLayout from "./features/admin/AdminLayout";
import Login from "./features/admin/Login";
import Dashboard from "./features/admin/Dashboard";
import DashboardHome from "./features/admin/pages/DashboardHome";
import CategoryManagement from "./features/admin/pages/CategoryManagement";
import SchemeFeatureManagement from "./features/admin/pages/SchemeFeatureManagement";
import SchemeFeatureEdit from "./features/admin/pages/SchemeFeatureEdit";
import UserManagement from "./features/admin/pages/UserManagement";
import AddonsManagement from "./features/admin/pages/AddonsManagement";

// Buy
import TbPaymentSuccess from "./features/buy/pages/tbPaymentSuccess";
import TbPclAgreementPage from "./features/buy/pages/TbPclAgreementPage";
import TbPClAgreementConfirm from "./features/buy/pages/tbPclAgreementConfirm";
import TbPClAgreementCancel from "./features/buy/pages/tbPclAgreementCancel";
import TbPclAgreementDecline from "./features/buy/pages/tbPclAgreementDecline";
import TbPClAgreementError from "./features/buy/pages/tbPclAgreementError";
import ErrorBoundary from "./shared/components/ErrorBoundary";

const root = (
  <ErrorBoundary>
    <Helmet>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
      />
      <link
        rel="icon"
        href={assetUrl("./assets/favicon/favicon.ico")}
        sizes="32x32"
      />
      <link
        rel="apple-touch-icon"
        href={assetUrl("./assets/favicon/apple-touch-icon.png")}
      />
      <link rel="stylesheet" href={assetUrl("./styles/main.css")} />
      <link
        rel="stylesheet"
        href={assetUrl("./styles/tailwind.generated.css")}
      />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Schibsted+Grotesk:wght@400;500;600;700;800;900&display=swap"
      />
      <script
        src="https://code.jquery.com/jquery-3.7.1.js"
        integrity="sha384-wsqsSADZR1YRBEZ4/kKHNSmU+aX8ojbnKUMN4RyD3jDkxw5mHtoe2z/T/n4l56U/"
        crossOrigin="anonymous"
      ></script>
      <script src={assetUrl("./features/buy/dist/rxp-js.js")}></script>
    </Helmet>

    <LiveChatScript />
    <div className="tw-min-h-screen tw-bg-dis-page tw-font-normal tw-text-dis-base tw-leading-[1.5] tw-text-dis-text-2 [&_*]:tw-box-border [&_button]:tw-appearance-none [&_button]:tw-border-solid [&_button]:tw-font-bold">
    <Routes>
      {/* Public */}
      <Route exact path="/" element={<UberAuthRedirect />} />
      <Route exact path="/login/uber" element={<UberAuthCallback />} />
      <Route exact path="/error" element={<ErrorPage />} />
      <Route exact path="/blocked-action" element={<BlockedAction />} />
      <Route exact path="/privacy" element={<PrivacyPolicyPage />} />
      <Route exact path="/taxi/quote" element={<TaxiLandingPage />} />
      <Route
        exact
        path="/taxi/quote/start"
        element={
          <ProtectedRoute>
            <TaxiJourney />
          </ProtectedRoute>
        }
      />

      {/* Protected */}
      <Route element={<ProtectedRoute />}>
        <Route path="/landing" element={<LandingLayout />}>
          <Route index element={<HomePage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>
        <Route exact path="/support" element={<Support />} />
        <Route exact path="/claim" element={<ReportClaimLayout />} />
        <Route exact path="/documents" element={<PortalDocuments />} />
      </Route>

      {/* Admin */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Login />} />
        <Route path="dashboard" element={<Dashboard />}>
          <Route index element={<DashboardHome />} />
          <Route path="categories" element={<CategoryManagement />} />
          <Route path="scheme-features" element={<SchemeFeatureManagement />} />
          <Route
            path="scheme-features/edit/:id"
            element={<SchemeFeatureEdit />}
          />
          <Route path="scheme-features/new" element={<SchemeFeatureEdit />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="addons" element={<AddonsManagement />} />
        </Route>
      </Route>

      {/* Buy */}
      <Route exact path="/agreement/pcl" element={<TbPclAgreementPage />} />
      <Route
        exact
        path="/agreement/pcl/error"
        element={<TbPClAgreementError />}
      />
      <Route
        exact
        path="/agreement/pcl/cancel"
        element={<TbPClAgreementCancel />}
      />
      <Route
        exact
        path="/agreement/pcl/confirm"
        element={<TbPClAgreementConfirm />}
      />
      <Route
        exact
        path="/agreement/pcl/decline"
        element={<TbPclAgreementDecline />}
      />
      <Route exact path="/payment/success" element={<TbPaymentSuccess />} />

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
    </div>
  </ErrorBoundary>
);

export default root;
